import { router } from 'expo-router';
import * as React from 'react';
import {
    BodyLargeRegular,
    H5Emphasized,
    Icon,
    isWeb,
    ScanFaceIcon,
    Shadows,
    View,
    YStack,
} from 'smoothie';

import KycButton from './KycButton';

const UnderReview = () => {
    return (
        <YStack
            flex={1}
            justifyContent={isWeb ? 'flex-start' : 'space-between'}
            gap={isWeb ? 60 : 16}
        >
            <View>
                <View
                    alignSelf="center"
                    padding={25}
                    borderRadius={20}
                    backgroundColor="$white"
                    marginTop={30}
                    marginBottom={30}
                    style={{ ...Shadows.MEDIUM }}
                >
                    <Icon icon={ScanFaceIcon} color="$black" size={30} />
                </View>
                <H5Emphasized textAlign="center" marginBottom={14}>
                    We&apos;re reviewing your information
                </H5Emphasized>
                <BodyLargeRegular textAlign="center" color="$gray1000">
                    A Fruitful team member may reach out for additional
                    information.
                </BodyLargeRegular>
            </View>
            <KycButton
                onPress={() => {
                    router.replace('/home');
                }}
                text="Back to home"
                hideSecureText
            />
        </YStack>
    );
};

export default UnderReview;
